import React from 'react';
import { MediaAttachment } from './MediaAttachment';

const STATUS = { sent: 'Enviado', delivered: 'Entregado', read: 'Leído', failed: 'Falló', undelivered: 'No entregado', received: '' };
const author = (m) => {
  if (m.direction === 'in') return '';
  if (m.author === 'template') return 'Plantilla de bienvenida';
  if (m.author === 'hours_notice') return 'Aviso automático · fuera de horario';
  if (m.author === 'ticket_notice') return 'Aviso automático · ticket creado';
  if (m.author === 'ai') return m.approved_by ? `IA · aprobado por ${m.approved_by}${m.edited ? ' (editado)' : ''}` : 'Agente IA (automático)';
  return (m.author || '').replace('agent:', '');
};

export function MessageBubble({ m }) {
  const out = m.direction === 'out';
  const bad = ['failed', 'undelivered'].includes(m.status);
  const legacyType = /\[Adjunto: ([^\]]+\/[^\]]+)\]/.exec(m.body || '')?.[1] || '';
  const media = m.media?.length ? m.media : (m.media_url ? [{ url: m.media_url, content_type: legacyType }] : []);
  return (
    <div className={`flex ${out ? 'justify-end' : 'justify-start'}`} data-testid={`whatsapp-msg-${m.id}`}>
      <div className={`max-w-[78%] rounded-lg px-3 py-2 text-sm whitespace-pre-wrap ${out ? 'bg-emerald-900/50 border border-emerald-700/40' : 'bg-[hsl(var(--card))] border border-[hsl(var(--border))]'}`}>
        {out && <div className="text-[10px] text-emerald-300/80 mb-1">{author(m)}</div>}
        {m.body}
        {media.map((x, i) => <MediaAttachment key={i} msgId={m.id} idx={i} contentType={x.content_type} />)}
        <div className={`text-[10px] mt-1 text-right ${bad ? 'text-red-300' : 'text-[hsl(var(--muted-foreground))]'}`} title={m.error || ''}>
          {new Date(m.created_at).toLocaleString('es', { hour: '2-digit', minute: '2-digit', day: '2-digit', month: 'short' })}
          {out && STATUS[m.status] ? ` · ${STATUS[m.status]}` : ''}
          {m.error ? ` · ${m.error}` : ''}
        </div>
      </div>
    </div>
  );
}
